<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="司机身份认证名称">
          <el-input placeholder="请输入司机身份认证名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="diauth_id" label="ID"></el-table-column>

            <el-table-column prop="user.nickName" label="用户"></el-table-column>
      
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="联系方式"></el-table-column>
            <el-table-column prop="idcard_positive" label="身份证正面">
              <template slot-scope="scope">
              <div v-if="scope.row.idcard_positive">
                <img :src="scope.row.idcard_positive" width="50px" height="50px"/>
              </div>
            </template>
            </el-table-column>
            <el-table-column prop="idcard_reverse" label="身份证反面">
              <template slot-scope="scope">
              <div v-if="scope.row.idcard_reverse">
                <img :src="scope.row.idcard_reverse" width="50px" height="50px"/>
              </div>
            </template>
            </el-table-column>
            <el-table-column prop="dr_card" label="驾驶证">
              <template slot-scope="scope">
              <div v-if="scope.row.dr_card">
                <img :src="scope.row.dr_card" width="50px" height="50px"/>
              </div>
            </template>
            </el-table-column>

            <el-table-column prop="audit_status" label="状态">
              <template slot-scope="scope">

                <div v-if="scope.row.audit_status == 0">未审核</div>
                <div v-if="scope.row.audit_status == 1">审核通过</div>
                <div v-if="scope.row.audit_status == 2">审核不通过</div>
              </template>


            </el-table-column>
            <el-table-column prop="reject_reason" label="不通过原因"></el-table-column>


            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button v-if="scope.row.audit_status == 0" @click="auditClick(scope.row.diauth_id)" type="text" size="small">审核</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :diauth_id="diauth_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>


       <!-- 审核 -->
       <el-dialog
      title="提示"
      :visible.sync="audit_flag"
      width="30%"
      >
      <el-radio-group v-model="obj.audit_status">
        <el-radio  :label="1"  >审核通过</el-radio>
        <el-radio  :label="2" >审核不通过</el-radio> 
      </el-radio-group>

      <el-input style="margin-top: 10px;" type="textarea" placeholder="请输入不通过原因" 
      v-model="obj.reject_reason" v-if="obj.audit_status == 2">

      </el-input>
     
      <span slot="footer" class="dialog-footer">
      <el-button @click="audit_flag = false">取 消</el-button>
      <el-button type="primary" @click="auditCoin()">确 定</el-button>
      </span>
    </el-dialog>
  
  </div>
</template>

<script>
  import DiauthApi from '@/api/diauth.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        diauth_id:"",
        dialogVisible:false,
        // 审核框显示
        audit_flag:false,
        obj:{
          audit_status:0,
          reject_reason:"",
          id:0,
        }
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      auditClick(id){
        this.audit_flag = true;
        this.obj.id = id
      },
      auditCoin(){
        var self = this;

        DiauthApi.audit(
              {
                id: self.obj.id,
                audit_status:self.obj.audit_status,
                reject_reason:self.obj.reject_reason,
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '审核成功',
                    type: 'success'
                  });
                  this.audit_flag = false;
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//司机身份认证标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        DiauthApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.diauth_id = row.diauth_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            DiauthApi.del(
              {
                diauth_id: row.diauth_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/diauth/index/index.vue